// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"e112a76d6d78d8647725","245":"881393e3ff58d36c78a2","452":"1714eec7ec04a5c74402","453":"cc6d7a718dcf9aa092dc"}[chunkId] + ".js";
};